
/**
 * Utilitários de Validação Raizama Garden CARE
 */

/**
 * Remove todos os caracteres não numéricos de uma string
 */
export const cleanNonDigits = (value: string): string => {
  return value.replace(/\D/g, '');
};

/**
 * Valida se um CPF é real e válido algoritmicamente
 */
export const validateCPF = (cpf: string): boolean => {
  const cleanCPF = cleanNonDigits(cpf);

  if (cleanCPF.length !== 11) return false;

  // Bloqueia CPFs com todos os números iguais (ex: 111.111.111-11)
  if (/^(\d)\1+$/.test(cleanCPF)) return false;

  let sum = 0;
  let remainder;

  // Validação do primeiro dígito verificador
  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(cleanCPF.substring(i - 1, i)) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCPF.substring(9, 10))) return false;

  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(cleanCPF.substring(i - 1, i)) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCPF.substring(10, 11))) return false;

  return true;
};

/**
 * Formata uma string para o padrão de CPF (000.000.000-00)
 */
export const formatCPF = (value: string): string => {
  const cleanValue = cleanNonDigits(value);
  
  return cleanValue
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

/**
 * Valida se um CEP possui o formato correto (8 dígitos)
 */
export const validateCEP = (cep: string): boolean => {
  const cleanCEP = cleanNonDigits(cep);
  return cleanCEP.length === 8;
};

/**
 * Formata uma string para o padrão de CEP (00000-000)
 */
export const formatCEP = (value: string): string => {
  const cleanValue = cleanNonDigits(value);
  
  return cleanValue
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
};
